import React from "react";
import AdapterDateFns from "@material-ui/lab/AdapterDateFns";
import LocalizationProvider from "@material-ui/lab/LocalizationProvider";
import { CssBaseline, ThemeProvider } from "@material-ui/core";
import theme from "./theme";
import Router from "./Router";
import GlobalStyle from "./components/GlobalStyle";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";
import { DndProvider } from "react-dnd";
import { useDialogueState } from "./state/dialogue";
import { Amplify } from "aws-amplify";
import config from "./config";
import SessionRehydrator from "./components/SessionRehydrator";
import InternalError from "./pages/public/internal-error";
import { useGlobalState } from "./state/global";
import { isMobile } from "react-device-detect";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { isProd } from "./utils/is-prod";

Amplify.configure(config.amplify);

if (isProd()) {
  Sentry.init({
    dsn: config.talksig.sentryDsn,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1,
    environment: process.env.NODE_ENV,
  });
}

function App() {
  useGlobalState();
  useDialogueState();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyle />
        <Sentry.ErrorBoundary fallback={<InternalError />}>
          <DndProvider backend={isMobile ? TouchBackend : HTML5Backend}>
            <SessionRehydrator>
              <Router />
            </SessionRehydrator>
          </DndProvider>
        </Sentry.ErrorBoundary>
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
